// extracted by mini-css-extract-plugin
module.exports = {"articles":"Page_articles__SlM54"};